import type { SyntheticEvent } from "react";

/**
 * `onError` for a photo layered over a fallback (initials): hides the broken image so the fallback shows.
 * Stateless, so atoms and molecules can use it. Key the <img> by its URL so a new URL gets a fresh, visible element.
 */
export const hideBrokenImage = (event: SyntheticEvent<HTMLImageElement>): void => {
  event.currentTarget.style.display = "none";
};
